import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './Components/Layout/Layout';
import Home from './Components/Home/Home';
import ContactUs from './Components/ContactUs/ContactUs';
import LocationDetails from './Components/Home/LocationDetails'
import AboutUs from './Components/About/AboutUs';
import Booking from './Components/Booking/Booking';
import Domestic from './Components/TourPackages/Domestic/Domestic';
import SpecificDomesticDest from './Components/TourPackages/Domestic/SpecificDomesticDest';
import HoneyMoon from './Components/TourPackages/HoneyMoon/HoneyMoon';
import SpecificHM from './Components/TourPackages/HoneyMoon/SpecificHM';
import International from './Components/TourPackages/Inernational/International';
import MoreCards from './Components/TourPackages/Inernational/MoreCards';
import Specific from './Components/TourPackages/Inernational/Specific';
import FlightBooking from './Components/FlightBooking/FlightBooking';
import HotelReservation from './Components/HotelReservation/HotelReservation';

function App() {
  return (
    <Router>
      <Layout> 
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/flight-booking" element={<FlightBooking/>} />
          <Route path="/hotel-reservation" element={<HotelReservation/>} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/location/:id" element={<LocationDetails />} />
          <Route path="/domestic" element={<Domestic />} />
          <Route path="/domestic/:id" element={<SpecificDomesticDest />} />
          <Route path="/honeymoon" element={< HoneyMoon/>} />
          <Route path="/honeymoon/:id" element={<SpecificHM />} />
          <Route path="/international" element={< International/>} />
          <Route path="/international/:region" element={<MoreCards/>} />
          <Route path="/:area/:region" element={<Specific/>} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
